export default __webpack_public_path__ + "static/media/pc.da2fa187.png";